import { ContentContext, CountryContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import India from './india';
import UnitedStates from './united-states';

const Interstitial = (props) => {
  const countrySlug = useContext(CountryContext);
  const { page: pageContent } = useContext(ContentContext);

  switch (countrySlug) {
    case 'united-states':
      return pageContent['state-choropleth'] ?
        <UnitedStates content={pageContent['state-choropleth']} /> : null;
    case 'india':
      return pageContent['state-choropleth'] ?
        <India content={pageContent['state-choropleth']} /> : null;
    default:
      return null;
  }
};

export default Interstitial;
